import React from "react";

type Link = {
  href: string;
  src: string;
};
const link: Link = {
  href: 'https://play.google.com/store/apps/details?id=ciup.portal.app&gl=FR&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
  src: 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
};

const PlayStoreLink: React.FC = () => {

  return (
    <div className='flex place-self-center'>
      <a href={link.href} className='w-google'>
        <img className="w-google object-cover" alt='Get it on Google Play' src={link.src} />
      </a>
    </div>
  );
};

export default PlayStoreLink;